import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page not found · Tech Emergency"
        description="That page couldn't be found. Head back to the Tech Emergency home page or call 1800 836 390."
        path="/"
        noIndex
      />
      <section className="min-h-[60vh] flex items-center justify-center px-4 te-noise">
        <div className="text-center">
          <div className="te-overline mb-4">/ 404</div>
          <h1 className="text-6xl sm:text-7xl font-bold tracking-tighter mb-4">Lost connection.</h1>
          <p className="text-zinc-400 mb-8">This page couldn&apos;t be found.</p>
          <Link to="/" className="te-btn te-btn-primary">Back home</Link>
        </div>
      </section>
    </>
  );
}
